import React from 'react';
import { CenterPopup } from 'antd-mobile';
import RelateAttrModal from '../../ProductMenu/RelateAttrModal';
import intl from 'react-intl-universal';

const AttrSelectPopup = ({ visible, onClose, product, addToCart, addBehavior = false, placeFlag = 0 }) => (
  <CenterPopup
    className='product-detail-modal'
    visible={visible}
    width={window.innerWidth}
    closeOnMaskClick
    onClose={onClose}
    onMaskClick={onClose}
    bodyStyle={{ backgroundColor: 'transparent', padding: 0, zIndex: 1000 }}
    style={{ '--z-index': '1999' }}
    aria-label={intl.get('attr_select_popup').d('Attribute Selection')}
  >
    <RelateAttrModal
      product={product}
      addToCart={addToCart}
      onCallback={onClose}
      addBehavior={addBehavior}
      placeFlag={placeFlag}
    />
  </CenterPopup>
);

export default AttrSelectPopup; 